<script>
    import { page } from '$app/stores';
    
    import { http_status_text } from '$lib/app/lib.js';

    import Page from '$lib/Page.svelte';

</script>
<Page long_page_footer={false}>
<h1 class=fr1><div class=errNo>{$page.status}</div> {$page.error.message == "" ? http_status_text($page.status) : $page.error.message}</h1>

<a href=/ class='hidden-link'><h1 class=fr1>&#x3C;</h1></a>
</Page>

<style>

.hidden-link {
    color: inherit;
}

.hidden-link:hover {
    color: #3847BB;
}

.errNo {
        padding-left: 0.1em;
        padding-right: 0.1em;
        border-radius: 2px;
        border-width: 1px;
        display: inline;
}

@media (prefers-color-scheme: light) {
    .errNo {
        color: white;
        background-color: red;
        border: solid black;
    }
}

@media (prefers-color-scheme: dark) {
    .errNo {
        color: var(--bulma-body-color);
        /*background-color: red;*/
        border: solid var(--bulma-body-color);
    }
}

</style>